export default __webpack_public_path__ + "static/media/news_plugin_assistant_optm.c69cbfb1.svg";